import { useEffect, useRef, useState } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import { X } from 'lucide-react';

interface BarcodeScannerProps {
  onScan: (barcode: string) => void;
  onClose: () => void;
}

export default function BarcodeScanner({ onScan, onClose }: BarcodeScannerProps) {
  const scannerRef = useRef<Html5Qrcode | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const scanner = new Html5Qrcode('barcode-reader');
    scannerRef.current = scanner;

    scanner.start(
      { facingMode: 'environment' },
      {
        fps: 10,
        qrbox: { width: 280, height: 150 },
        aspectRatio: 1.0,
      },
      (decodedText) => {
        scanner.stop().catch(() => {});
        onScan(decodedText);
      },
      () => {} // ignore scan failures (expected while aiming)
    ).catch((err) => {
      setError('Não foi possível acessar a câmera. Verifique as permissões.');
      console.error('BarcodeScanner start error:', err);
    });

    return () => {
      scanner.stop().catch(() => {});
    };
  }, [onScan]);

  return (
    <div className="fixed inset-0 z-50 bg-black flex flex-col">
      {/* Header */}
      <div className="flex items-center justify-between p-4 bg-black/80">
        <h2 className="text-white font-semibold">Escanear Código de Barras</h2>
        <button onClick={onClose} className="p-2 rounded-full bg-white/20">
          <X className="h-5 w-5 text-white" />
        </button>
      </div>

      {/* Scanner */}
      <div className="flex-1 flex items-center justify-center">
        {error ? (
          <div className="text-center px-8">
            <p className="text-white text-sm mb-4">{error}</p>
            <button
              onClick={onClose}
              className="px-6 py-3 bg-white text-black rounded-xl font-medium"
            >
              Fechar
            </button>
          </div>
        ) : (
          <div id="barcode-reader" className="w-full max-w-sm" />
        )}
      </div>

      {/* Instructions */}
      <div className="p-4 bg-black/80 text-center">
        <p className="text-white/70 text-sm">
          Aponte a câmera para o código de barras do produto
        </p>
      </div>
    </div>
  );
}
